<div class="m-3">
  <div class="bg-white rounded shadow">
    <div class="my-4">
      <app-tabs [tabList]="tabs" (onSelectTab)="onChangeTab($event)" />
    </div>
  </div>

  <div class="d-grid profile-box">
    <div class="bg-white rounded shadow">
      @if (avatarForm) {
        <div class="d-flex flex-column justify-content-center align-items-center gap-2 m-4" [formGroup]="avatarForm">
          <label class="click-css profile-upload">
            <input
              hidden
              type="file"
              accept="image/*"
              [formControl]="avatarForm.controls.file"
              (change)="onFileChange($event)"
            />
            @if (avatarForm.controls.file.value) {
              <img [src]="getURL()" alt="avatar" />
            } @else {
              @if (!baseService.currentUserInfo.avatar_url) {
                <img src="/assets/svgs/special/profile.svg" alt="avatar" />
              }
              @if (baseService.currentUserInfo.avatar_url) {
                <img [src]="baseService.currentUserInfo.avatar_url" alt="avatar" />
              }
            }
            <div class="hover-effect">
              <app-icon>camera_enhance</app-icon>
            </div>
          </label>
          <span class="fs-3"
            >{{ baseService.currentUserInfo.first_name | fullName: baseService.currentUserInfo.last_name }}</span
          >
          @if (avatarForm.controls.file.value) {
            <div class="d-flex gap-3">
              <app-button btnType="stroked" (onChangeClick)="resetFile()">{{ 'cancel' | translate }}</app-button>
              <app-button (onChangeClick)="saveFile()">{{ 'save' | translate }}</app-button>
            </div>
          }
        </div>
      }
    </div>
    @if (activeTab) {
      @switch (activeTab.value) {
        @case (ProfileTab.PROFILE) {
          <div class="bg-white rounded shadow">
            <div class="profile-edit-box m-4">
              @if (profileForm) {
                <div class="d-flex flex-column gap-3" [formGroup]="profileForm">
                  <app-text-field
                    label="{{ 'first_name' | translate }}"
                    [mask]="'K*'"
                    [required]="true"
                    placeholder="{{ 'enter_first_name' | translate }}"
                    [formControl]="profileForm.controls.first_name"
                    [error]="formSubmitted && profileForm.controls['first_name'].status === 'INVALID'"
                  ></app-text-field>
                  @if (formSubmitted && profileForm.controls['first_name'].status === 'INVALID') {
                    <div class="d-flex align-items-center">
                      <span class="danger-hint">{{ 'field_cannot_be_empty' | translate }}.</span>
                    </div>
                  }
                  <app-text-field
                    [mask]="'K*'"
                    label="{{ 'last_name' | translate }}"
                    [required]="true"
                    placeholder="{{ 'enter_last_name' | translate }}"
                    [formControl]="profileForm.controls.last_name"
                    [error]="formSubmitted && profileForm.controls['last_name'].status === 'INVALID'"
                  ></app-text-field>
                  @if (formSubmitted && profileForm.controls['last_name'].status === 'INVALID') {
                    <div class="d-flex align-items-center">
                      <span class="danger-hint">{{ 'field_cannot_be_empty' | translate }}.</span>
                    </div>
                  }
                  <app-input
                    labelType="floating"
                    inputType="phone-v2"
                    [required]="true"
                    [formControl]="profileForm.controls.phone"
                    [invalid]="
                      formSubmitted &&
                      profileForm.controls['phone'].status === 'INVALID' &&
                      profileForm.controls.phone.touched
                    "
                    [disabled]="true"
                  ></app-input>
                  @if (formSubmitted && profileForm.controls['phone'].status === 'INVALID') {
                    <div class="d-flex align-items-center getPhoneValidationError">
                      <span class="danger-hint">{{ getPhoneValidationError() }}</span>
                    </div>
                  }
                  <app-input
                    labelType="floating"
                    label="Email"
                    placeholder="example@gmail.com"
                    [required]="true"
                    [formControl]="profileForm.controls.email"
                    [invalid]="formSubmitted && profileForm.controls['email'].status === 'INVALID'"
                    [disabled]="true"
                  ></app-input>
                  @if (formSubmitted && profileForm.controls['email'].status === 'INVALID') {
                    <div class="d-flex align-items-center">
                      <span class="danger-hint">
                        {{ 'field_cannot_be_empty' | translate }}, {{ 'and_must_be_an_email_address' | translate }}.
                      </span>
                    </div>
                  }
                </div>
              }
              <app-button [disabled]="isChangeData()" (onChangeClick)="saveProfile()">{{
                'save' | translate
              }}</app-button>
            </div>
          </div>
        }
        @case (ProfileTab.SETTINGS) {
          @if (passwordForm) {
            <div class="bg-white rounded shadow">
              <div class="profile-edit-box m-4">
                @if (profileForm) {
                  <div class="d-flex flex-column gap-2" [formGroup]="profileForm">
                    <app-text-field
                      label="{{ 'profile_new_password_label' | translate }}"
                      [required]="true"
                      placeholder="{{ 'profile_new_password_placeholder' | translate }}"
                      [formControl]="passwordForm.controls.new_password"
                      [error]="formSubmitted && passwordForm.controls['new_password'].status === 'INVALID'"
                    ></app-text-field>
                    @if (formSubmitted && passwordForm.controls['new_password'].status === 'INVALID') {
                      <div class="d-flex align-items-center">
                        <span class="danger-hint">{{ 'field_cannot_be_empty' | translate }}.</span>
                      </div>
                    }
                    <app-text-field
                      label="{{ 'profile_confirm_password_label' | translate }}"
                      [required]="true"
                      placeholder="{{ 'profile_confirm_password_placeholder' | translate }}"
                      [formControl]="passwordForm.controls.confirm_password"
                      [error]="passwordMismatch"
                    ></app-text-field>
                    @if (passwordMismatch) {
                      <div class="d-flex align-items-center">
                        <span class="danger-hint">{{ 'profile_passwords_do_not_match' | translate }}.</span>
                      </div>
                    }
                  </div>
                }
                <app-button [disabled]="passwordForm.invalid || !passwordForm.dirty" (onChangeClick)="changePassword()">
                  {{ 'change_password' | translate }}
                </app-button>
              </div>
            </div>
          }
        }
      }
    }
  </div>
</div>
